import { ChainId } from './chainId'

export const MULTICALL_ADDRESS = {
  [ChainId.Mainnet]: '0xeefba1e63905ef1d7acba5a8513c70307c1ce441',
  [ChainId.Kovan]: '0x2cc8688c5f75e365aaeeb4ea8d6a480405a48d2a',
  [ChainId.Ganache]: '0xBCa5c1cBc034C0AF31D976a4e3a36951A537eD77',
}

export const FACTORY_ADDRESS = {
  [ChainId.Mainnet]: '0x673662e97B05e001816c380bA5a628D2E29f55D1',
  [ChainId.Kovan]: '0xf656eb4f9f9f108e618Ede0022cD0E442cEfe833',
  [ChainId.Ganache]: '0xD756fb6A081CC11e7F513C39399DB296b1DE3036',
}

export const READER_ADDRESS = {
  [ChainId.Mainnet]: '0xB2587B00f3EAef6037e70da7d0005B3fC6D353a3',
  [ChainId.Kovan]: '0x5a82eC7076a3Fb9Fc10e5D90e1cDA15372864c39',
  [ChainId.Ganache]: '0x0b156472D34e81765E0B2D440188f248bf2D0382',
}

export const DELAY_ADDRESS = {
  [ChainId.Mainnet]: '0x3EeDC524c234a5b72c09A4B052e7da695e9e7713',
  [ChainId.Kovan]: '0x6Ad48228c75B75Cb3ec8759dd33E28fE9fC711E5',
  [ChainId.Ganache]: '0x84e924C5E04438D2c1Df1A981f7E7104952e6de1',
}

export const TIME_RELEASE_ADDRESS = {
  [ChainId.Mainnet]: '0xc8805CeBD927941a3B26e2EDCed20d666Fb118Ba',
  [ChainId.Kovan]: '0xF86a107c4025bD7D53544788A457E50fbfb6ebC4',
  [ChainId.Ganache]: '',
}

export const SIX_MONTHS_STAKING_ADDRESS = {
  [ChainId.Mainnet]: '0x36bD665392236b20bd42e161f02Bf0ae1d9441Ff',
  [ChainId.Kovan]: '0xd514094E40d9Abf634B7586e6F045b9046aCbc77',
  [ChainId.Ganache]: '',
}

export const THREE_YEARS_STAKING_ADDRESS = {
  [ChainId.Mainnet]: '0xFFc0EAC1a1aE79C697607229Aca43Ef422625a40',
  [ChainId.Kovan]: '0xA56989c1FA2a9041C45AA50af772f34f03796100',
  [ChainId.Ganache]: '',
}

export const DEPRECATED_SIX_MONTHS_STAKING_ADDRESS = {
  [ChainId.Mainnet]: '0x90477da311c24dB29e0f50D869E4AbE0820ECae8',
  [ChainId.Kovan]: '0xB78F5AF1598656Ac666F816d312Ae04203207076',
  [ChainId.Ganache]: '',
}

export const DEPRECATED_THREE_YEARS_STAKING_ADDRESS = {
  [ChainId.Mainnet]: '0xFDED703178Fac52799320BC0244aeD7dde0b330F',
  [ChainId.Kovan]: '0x15A6Aef205899C417D9f6B8ef38075D78A67cB76',
  [ChainId.Ganache]: '',
}

// TOKENS

export const INTEGRAL = {
  [ChainId.Mainnet]: '0xD502F487e1841Fdc805130e13eae80c61186Bc98',
  [ChainId.Kovan]: '0x597F10966E918d099Bfc30516ce2368DcCacf321',
  [ChainId.Ganache]: '',
}

export const WBTC = {
  [ChainId.Mainnet]: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
  [ChainId.Kovan]: '0xECC7Fe95dE1E44871246122cfEC2193fd4053ba3',
  [ChainId.Ganache]: '0xA193E42526F1FEA8C99AF609dcEabf30C1c29fAA',
}

export const USDC = {
  [ChainId.Mainnet]: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  [ChainId.Kovan]: '0xc6E44B1222630ad4b35b387540a0bBEF06F7D079',
  [ChainId.Ganache]: '0xFDFEF9D10d929cB3905C71400ce6be1990EA0F34',
}

export const USDT = {
  [ChainId.Mainnet]: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  [ChainId.Kovan]: '0x5382Cf820033Ff6cB5453A88F58B9a4c8e9B52cB',
  [ChainId.Ganache]: '0xaC8444e7d45c34110B34Ed269AD86248884E78C7',
}

export const DAI = {
  [ChainId.Mainnet]: '0x6b175474e89094c44da98b954eedeac495271d0f',
  [ChainId.Kovan]: '0xbd4ff4544de1AAbCCC142Fd47F5119e27822F6C3',
  [ChainId.Ganache]: '0x94BA4d5Ebb0e05A50e977FFbF6e1a1Ee3D89299c',
}

export const WETH = {
  [ChainId.Mainnet]: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  [ChainId.Kovan]: '0xd0A1E359811322d97991E03f863a0C30C2cF029C',
  [ChainId.Ganache]: '0xD756fb6A081CC11e7F513C39399DB296b1DE3036',
}

export const LINK = {
  [ChainId.Mainnet]: '0x514910771af9ca656af840dff83e8264ecf986ca',
  [ChainId.Kovan]: '0x8eF1F33C542fa06d0e1eFC7d09cB22F49B7103BD',
  [ChainId.Ganache]: '0xFf807885934003A35b1284d7445fc83Fd23417e5',
}

// PAIRS

export const WETH_WBTC = {
  [ChainId.Mainnet]: '0x5dFAe56E344B18bC7cd3B8350721FfdD12Ff2b3C',
  [ChainId.Kovan]: '0x04137adB16254857f1569b94382A04CAA1Dfe3c5',
  [ChainId.Ganache]: '0x42E848b7F6bfaEB5a9a1937e418566BDA3352C33',
}

export const WETH_USDC = {
  [ChainId.Mainnet]: '0x8b0Bb0d0D8B3D83EBb7c1B49d79D74dF396634c6',
  [ChainId.Kovan]: '0x489453a8B2383969905Ce458930b876C8b74547E',
  [ChainId.Ganache]: '0x069f0b1C9fC970a6B5dEe10C66059d84c934C1C9',
}

export const WETH_USDT = {
  [ChainId.Mainnet]: '0x3eD27247A8abF40d3D85171536ea98e5eEd94F40',
  [ChainId.Kovan]: '0xA639BC1c8B32eA5103B850d4664e89fF7CE97781',
  [ChainId.Ganache]: '0x79CF3483A993832561f61f4d0B2B1edf4EBF08ba',
}

export const WETH_DAI = {
  [ChainId.Mainnet]: '0x5FB51deDd29b8C065cA3Ac4545b6c58b635616C5',
  [ChainId.Kovan]: '0x55AaAa1fD4247f25D92080CB2E6AfE15c9d73637',
  [ChainId.Ganache]: '0x2F1e157D8aD8Effd02b409D74871f0871C3C2E15',
}

export const WETH_LINK = {
  [ChainId.Mainnet]: '0x4370CFD2c62b6E2900D04af97c4D9552484C0e48',
  [ChainId.Kovan]: '0x49988422155D981f43A795252fd15398fBF85075',
  [ChainId.Ganache]: '0x3Ff7491b4Af201c48f7da81928eC8e275Cc0cD23',
}

export const DAI_USDC = {
  [ChainId.Mainnet]: '0x01d9984489bD4c5f372a6e6Eca1F22c27A77e355',
  [ChainId.Kovan]: '0xda70F0f062F79C7d112b272F171b9a0e2Ffd802C',
  [ChainId.Ganache]: '',
}

export const DAI_USDT = {
  [ChainId.Mainnet]: '0xcddD3B9EACce44DDf9d5748C8e8b5F8d630f17EB',
  [ChainId.Kovan]: '0x138Dba02F481A637A1F586D737e7A9896191b267',
  [ChainId.Ganache]: '',
}

export const USDC_USDT = {
  [ChainId.Mainnet]: '0x3fFecc12a6B46C3Aa32aEA38ac34EfbB6C9B6052',
  [ChainId.Kovan]: '0xcE2951067a1b4479809adED7eFE7061CF84bFff4',
  [ChainId.Ganache]: '',
}

export const UNISWAP_V3_BASED_PAIRS = [DAI_USDC, DAI_USDT, USDC_USDT]
